import { TAttributesConfig, TConfiguratorSections } from "./types";
import { MoneyFormatter } from "../../../Utils/Money";
import { SELECTORS as RATE_CALCULATOR_SELECTORS } from "../../RateCalculator/Constants";
import { initQuantityFields, removeQuantityListeners } from "../Quantity";
import { SELECTORS } from "./Constants";

export const ATTRIBUTES: TAttributesConfig = {
    price: {
        elements: [
            {
                selector: SELECTORS.PRICE,
                transform: (v: number) => {
                    return new MoneyFormatter().noDecimals().stripSymbol().format(v);
                }
            },
            {
                selector: SELECTORS.PRICE_STICKY,
                transform: (v: number) => {
                    return new MoneyFormatter().noDecimals().stripSymbol().format(v);
                }
            },
            {
                selector: RATE_CALCULATOR_SELECTORS.container,
                dataset: "price"
            }
        ]
    },
    compare_at_price: {
        elements: [
            {
                selector: SELECTORS.PRICE_OLD,
                transform: (v: number) => {
                    return new MoneyFormatter().noDecimals().stripSymbol().format(v);
                }
            }
        ]
    },
    id: {
        elements: [
            {
                selector: SELECTORS.CTA,
                dataset: "variant"
            },
            {
                selector: SELECTORS.CTA_STICKY,
                dataset: "variant"
            }
        ]
    }
};

export const SECTIONS: TConfiguratorSections = {
    AVAILABILITIES: {
        section: "pdp-configurator-availabilities",
        selectorOld: SELECTORS.AVAILABILITIES,
        selectorNew: SELECTORS.SECTION_AVAILABILITIES,
        replaceMode: "childNodes"
    },
    QUANTITY: {
        section: "pdp-configurator-quantity",
        selectorOld: SELECTORS.QUANTITY,
        selectorNew: SELECTORS.SECTION_QUANTITY,
        replaceMode: "all",
        hooks: {
            before: () => removeQuantityListeners(),
            after: () => initQuantityFields()
        }
    },
    HIGHLIGHTS: {
        section: "pdp-configurator-highlights",
        selectorOld: SELECTORS.HIGHLIGHTS,
        selectorNew: SELECTORS.SECTION_HIGHLIGHTS,
        replaceMode: "all"
    },
    ATTRIBUTES: {
        section: "pdp-configurator-attributes",
        selectorOld: SELECTORS.ATTRIBUTES,
        selectorNew: SELECTORS.SECTION_ATTRIBUTES,
        replaceMode: "childNodes"
    }
};
